export const tailwindConfig = {
  fontFamily: {
    sans: ['Nunito', 'sans-serif'],
    montserrat: ['Nunito', 'sans-serif'],
  },
  extend: {
    colors: {
      primeval: {
        50: '#FFE5F3',
        100: '#FFCCE7',
        200: '#FF99CF',
        300: '#FF66B7',
        400: '#FF339F',
        500: '#FF4BB3',
        600: '#CC398E',
        700: '#992769',
        800: '#661544',
        900: '#33021F',
        950: '#1A0110',
      },
      leftArrow: '#f9f1f1ff',
    },
    fontSize: {
      '2xs': ['0.625rem', '0.75rem'],
    },
    height: {
      26: '6.5rem',
    },
    width: {
      26: '6.5rem'
    },
    minHeight: {
      18: '4.5rem',
    },
    borderWidth: {
      '1.5': '1.5px',
    },
  }
};